
import { Mail, MapPin, Calendar } from 'lucide-react';

const ContactInfo = () => {
  return (
    <div className="group bg-neutral-white rounded-xl shadow-xl border border-neutral-border hover:shadow-2xl hover:border-trust-primary transition-all duration-300 transform hover:-translate-y-1 p-8 overflow-hidden">
      <div className="h-1 bg-gradient-to-r from-trust-primary to-success-primary -mx-8 -mt-8 mb-6"></div>

      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-authority-navy mb-2">Thank You, Colorado</h3>
        <p className="text-trust-primary font-semibold mb-4">8 years &middot; 18,000+ jobs &middot; family-owned</p>
        <p className="text-neutral-gray leading-relaxed">
          Colorado First Plumbing and Sewer LLC permanently closed in March 2026. We&rsquo;re no longer scheduling service visits, but we still read messages and can refer you to a trusted, licensed plumber serving your area.
        </p>
      </div>

      <div className="space-y-6">
        <ContactInfoItem
          icon={<Mail size={20} />}
          iconBg="from-trust-primary to-trust-deep"
          title="Email Us"
          content={
            <div className="bg-trust-light border border-trust-primary/20 rounded-lg p-3">
              <a href="mailto:contact@bestmasterplumber.com" className="text-trust-primary hover:text-action-primary transition-colors font-semibold">
                contact@bestmasterplumber.com
              </a>
              <p className="text-sm text-authority-dark font-medium mt-1">For referrals and general inquiries</p>
            </div>
          }
        />

        <ContactInfoItem
          icon={<Calendar size={20} />}
          iconBg="from-success-primary to-success-eco"
          title="Status"
          content={
            <div className="bg-neutral-light border border-neutral-border rounded-lg p-4">
              <p className="text-authority-navy font-semibold mb-1">Permanently Closed</p>
              <p className="text-sm text-neutral-gray">As of March 2026. The form on this page still goes to us &mdash; we&rsquo;ll forward your message.</p>
            </div>
          }
        />

        <ContactInfoItem
          icon={<MapPin size={20} />}
          iconBg="from-trust-primary to-success-primary"
          title="Areas We Served"
          content={
            <div className="bg-gradient-to-r from-trust-light to-success-light border border-trust-primary/20 rounded-lg p-4">
              <p className="text-authority-navy font-semibold mb-2">Denver Metro &amp; surrounding communities</p>
              <div className="grid grid-cols-2 gap-2 text-sm">
                <span className="bg-neutral-white px-2 py-1 rounded text-authority-dark font-medium">&middot; Highlands Ranch</span>
                <span className="bg-neutral-white px-2 py-1 rounded text-authority-dark font-medium">&middot; Littleton</span>
                <span className="bg-neutral-white px-2 py-1 rounded text-authority-dark font-medium">&middot; Castle Rock</span>
                <span className="bg-neutral-white px-2 py-1 rounded text-authority-dark font-medium">&middot; Lakewood</span>
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
};

interface ContactInfoItemProps {
  icon: React.ReactNode;
  iconBg: string;
  title: string;
  content: React.ReactNode;
}

const ContactInfoItem = ({ icon, iconBg, title, content }: ContactInfoItemProps) => (
  <div className="group">
    <div className="flex items-start">
      <div className={`p-3 rounded-lg bg-gradient-to-r ${iconBg} text-white mr-4 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
        {icon}
      </div>
      <div className="flex-1">
        <h4 className="font-bold text-lg mb-3 text-authority-navy">{title}</h4>
        {content}
      </div>
    </div>
  </div>
);

export default ContactInfo;
